export const SET_TASKS = 'SET_TASKS';
export const setTasks = (data) => {
  return {
    type: SET_TASKS,
    payload: data,
  };
};

export const tasks = (state = [], action) => {
  switch (action.type) {
    case SET_TASKS:
      return action.payload.tasks;
    default:
      return state;
  }
};
